import {Component, EventEmitter, Output} from '@angular/core';
import {NgClickOutsideDirective} from 'ng-click-outside2';
import {SimplebarAngularModule} from 'simplebar-angular';
import {Router, RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {TranslationService} from '../../core/services/translation/translation.service';
import {AuthenticationService} from '../../core/services/authentication/authentication.service';
import {LanguageSwitcherComponent} from '../../components/language-switcher/language-switcher.component';

@Component({
  selector: 'app-admin-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    SimplebarAngularModule,
    NgClickOutsideDirective,
    LanguageSwitcherComponent
  ],
  templateUrl: './admin-navbar.component.html',
  styleUrl: './admin-navbar.component.scss'
})
export class AdminNavbarComponent {
  show: boolean = true;
  notification:boolean = false;

  onClickedOutside(e: Event) {
    this.notification = false
  }

  user:boolean = false

  onClickedOutside2(e: Event) {
    this.user = false
  }

  @Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggleShow(e:any) {
    e.preventDefault();
    this.show = !this.show;
    this.showChange.emit(this.show);  // Emit the `show` value
  }
}
